import { BaseCommand } from '../../../core/commands/ICommand';
import type { PositionStructureIntent } from '../models/PositionStructureIntent';
import type { PositionStaffingCommandAccess, PositionStaffingCommandServerPort } from './PositionStaffingCommand';

export class PositionStructureCommand extends BaseCommand {
  get historyRecoveryId(): string | undefined { return this.input.serverPort.historyRecoveryId; }
  constructor(private readonly input: {
    intent: PositionStructureIntent;
    access: PositionStaffingCommandAccess;
    serverPort: PositionStaffingCommandServerPort;
    /** External/reviewed operational changes are reversed by a new change, not local undo. */
    skipHistory?: boolean;
  }) {
    super(positionStructureName(input.intent), undefined, { skipHistory: input.skipHistory });
  }

  canExecute(): boolean {
    return this.input.access.canWrite
      && (this.input.intent.mode === 'live' || this.input.access.canUseScenarios);
  }

  execute(): Promise<void> {
    if (!this.canExecute()) throw new Error('Position authoring is not available for this workspace.');
    return this.input.serverPort.execute();
  }

  undo(): Promise<void> { return this.input.serverPort.undo(); }
  redo(): Promise<void> { return this.input.serverPort.redo(); }
}

function positionStructureName(intent: PositionStructureIntent): string {
  if (intent.kind === 'create') return 'Create Position';
  if (intent.kind === 'edit') return 'Edit Position';
  if (intent.kind === 'reparent') return 'Change Reporting Line';
  if (intent.kind === 'add_seat') return 'Add Position Seat';
  if (intent.kind === 'duplicate') return 'Duplicate Position';
  return 'Retire Position';
}
